import * as moment from 'moment';

export class DateTimeFormatValueConverter {
    toView(value, formatCode) {
        if (value) {
            
            let formatString;
            
            if (formatCode) {
                formatString = formatCode;
            } else {
                formatString = "lll";
            }
            
            let theDate = moment(value);
            return moment(theDate).format(formatString);
            
            //return moment.utc(value).format('MMMM Do, YYYY h:mm a');
        } else {
            return "";
        }
    }
}